module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-pdf-ac2ea6d1de0afaa449adcf91789ae2ed.svg";